import { render, staticRenderFns } from "./EditHistoryView.vue?vue&type=template&id=71f91b21&scoped=true&"
import script from "./EditHistoryView.vue?vue&type=script&lang=ts&"
export * from "./EditHistoryView.vue?vue&type=script&lang=ts&"
import style0 from "./EditHistoryView.vue?vue&type=style&index=0&id=71f91b21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f91b21",
  null
  
)

export default component.exports